import leftPictureDark from 'img/vigbo/empty-sale/leftPictureDark.png';
import leftPictureLight from 'img/vigbo/empty-sale/leftPictureLight.png';
import { ReactComponent as LogoDarkIcon } from 'img/vigbo/empty-sale/logo-dark.svg';
import { ReactComponent as LogoLightIcon } from 'img/vigbo/empty-sale/logo-light.svg';
import rightPicture from 'img/vigbo/empty-sale/rightPicture.png';
import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    vigboAboutSubUrl,
    vigboDefaultTariff,
    vigboFeaturesPreviewPrimaryBttnText,
} from 'reactApp/appHelpers/featuresHelpers/features/vigbo';
import { getPaySource } from 'reactApp/modules/payment/payment.analytics';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { Button } from 'reactApp/ui/Button/Button';
import { BenefitCard } from 'reactApp/ui/EmptyVigboFeaturesPreview/BenefitCard/BenefitCard';
import { VIGBO_BENEFITS } from 'reactApp/ui/EmptyVigboFeaturesPreview/EmptyVigboFeaturesPreview.constants';
import opener from 'reactApp/utils/opener';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './EmptyVigboFeaturesPreview.css';

export const EmptyVigboFeaturesPreview = memo(function EmptyVigboFeaturesPreview() {
    const dispatch = useDispatch();

    const isDarkTheme = useSelector(isCurrentDarkTheme);

    useEffect(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.vigboEmptyFeatures,
            action: 'show',
        });
    }, []);

    const onAboutSubClick = () => {
        sendPaymentGa({
            eventCategory: ECategoryGa.vigboEmptyFeatures,
            action: 'click-about',
        });

        opener(vigboAboutSubUrl);
    };

    const onPrimaryClick = () => {
        sendPaymentGa({
            eventCategory: ECategoryGa.vigboEmptyFeatures,
            action: 'click',
        });

        if (!vigboDefaultTariff) {
            return;
        }

        productsController.updateProducts(vigboDefaultTariff).then((tariff) => {
            if (!tariff || !tariff.available) {
                return;
            }

            dispatch(
                openTariffBuy({
                    productId: tariff.id,
                    paySource: getPaySource('vigbo-features-preview'),
                    onSuccess: () => {
                        sendPaymentGa({
                            eventCategory: ECategoryGa.vigboEmptyFeatures,
                            action: 'buy',
                            tariff: tariff.id,
                        });
                    },
                })
            );
        });
    };

    return (
        <div className={styles.root}>
            <img className={styles.leftPicture} src={isDarkTheme ? leftPictureDark : leftPictureLight} alt="left picture" />
            <img className={styles.rightPicture} src={rightPicture} alt="right picture" />
            <div className={styles.content}>
                <div className={styles.textContent}>
                    <div className={styles.logo}>{isDarkTheme ? <LogoDarkIcon /> : <LogoLightIcon />}</div>
                    <div className={styles.title}>Тут будет раздел для фотографов </div>
                    <div className={styles.text}>
                        Подключите подписку для фотографов Mail Space и Vigbo, чтобы этот раздел стал доступен
                    </div>
                    <div className={styles.buttonsContainer}>
                        <Button className={styles.bttn} secondary theme="octavius" onClick={onAboutSubClick}>
                            О подписке
                        </Button>
                        <Button className={styles.bttn} primary theme="octavius" onClick={onPrimaryClick}>
                            {vigboFeaturesPreviewPrimaryBttnText}
                        </Button>
                    </div>
                </div>
                <div className={styles.benefitsContainter}>
                    {VIGBO_BENEFITS.map((props) => (
                        <BenefitCard key={props.text} {...props} />
                    ))}
                </div>
            </div>
        </div>
    );
});
